import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Geosuggest from 'react-geosuggest'; // https://github.com/ubilabs/react-geosuggest

class PrequalGeosuggest
    extends Component
{

    render() {
        const {
            input,
            meta: { touched, error },
            name,
            label,
            required,
            placeholder,
            autoFocus
        } = this.props;

        return <Geosuggest
            ref={el => this._geoSuggest = el}
            name="street"
            id="street"
            label="Street Address"
            placeholder={placeholder || ""}
            inputClassName="street__input"
            initialValue={input.value}
            // location=""
            country="us"
            types={['geocode']}
            placeDetailFields={['address_components']}
            className="geosuggest"
            suggestsclassName="geosuggest__suggests"
            suggestsHiddenclassName="'geosuggest__suggests--hidden"
            suggestItemclassName="geosuggest__item"
            suggestItemActiveclassName="'geosuggest__item--active"
            autocomplete="off"
            aria-label="Street Address"
            minLength="3"
            queryDelay="450"
            ignoreTab="true"
            country="US"
            autoFocus={autoFocus}
            onChange={(e) => {
                document.querySelector('ul[role="listbox"]').style.display = "block";
                return input.onChange(e);
            }}
            onSuggestSelect={(suggest) => {
                if (!suggest) return input.onChange(null);
                suggest.suggestSelect = true;
                return input.onChange(suggest);
            }}
            getSuggestLabel={(prediction) => {
                // default is prediction.description
                // see prediction_example.json

                let label = [prediction.terms[0].value, prediction.terms[1].value].join(' ');
                return label;
            }}
            onFocus={(e) => input.onFocus(e)}
            onBlur={(e) => input.onBlur(e)}
            renderSuggestItem={(prediction, userInput) => {
                // default is prediction.description
                // see prediction_example.json
                return prediction.description;
            }}
        />
    }
}

const mapStateToProps = (state) => ({
});

export {PrequalGeosuggest as PrequalGeosuggestPureComponent};
export default connect(mapStateToProps)(PrequalGeosuggest);



// WEBPACK FOOTER //
// ./src/components/PrequalGeosuggest/index.js